export interface GnomeSpineSkinRange {
    name: string;
    offset: number;
    length: number;
}
export interface GnomeSpinePackAsset {
    skins: readonly string[];
    dependencies: readonly string[];
    skeleton: string;
    atlas: string;
    images: Readonly<Record<string, string>>;
}
export interface GnomeSpinePackAssets {
    fingerprint: string;
    skinRanges: readonly GnomeSpineSkinRange[];
    packs: Readonly<Record<string, GnomeSpinePackAsset>>;
}

export function resolveGnomePackIds(
    assets: GnomeSpinePackAssets,
    skinNames: readonly string[],
): string[] {
    const ids = new Set(["core"]);
    for (const name of skinNames) {
        const entry = Object.entries(assets.packs).find(([, pack]) =>
            pack.skins.includes(name),
        );
        if (!entry) throw new Error(`Missing Gnome asset pack for ${name}.`);
        ids.add(entry[0]);
    }
    for (const id of ids) {
        const pack = assets.packs[id];
        if (!pack) throw new Error(`Missing Gnome pack dependency ${id}.`);
        for (const dependency of pack.dependencies) ids.add(dependency);
    }
    return [...ids];
}
